const motionEasingOut = 'cubic-bezier(0.4,0,0.5,1)';

export { motionEasingOut };
